import path from 'path'
import { fileExt } from '../constants/constants'

export const convertPathToNameImg = (path: string) => {
    if (path) {
        let startIndex = path.indexOf('\\') >= 0 ? path.lastIndexOf('\\') : path.lastIndexOf('/')
        let filename = path.substring(startIndex)
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            return filename.substring(1)
        }
    }
}

export const getFileIconPath = (filename: string) => {
    const extName = path.extname(`${filename}`)
    switch (extName) {
        case fileExt.pdf:
            return '/img/icons/pdf.png'
        case fileExt.doc:
            return '/img/icons/word.png'
        case fileExt.docx:
            return '/img/icons/word.png'
        case fileExt.tiff:
            return '/img/icons/other_docs.png'
        case fileExt.png:
            return '/img/icons/other_docs.png'
        case fileExt.jpg:
            return '/img/icons/other_docs.png'
        case fileExt.xls:
            return '/img/icons/excel.png'
        case fileExt.xlsx:
            return '/img/icons/excel.png'
        default:
            return '/img/icons/pdf.png'
    }
}
